<template>
  <div>
    <PageHeader page-title="Skills" wrapperClassName="" titleClassName="block-title">
      <template #buttons>
        <div class="d-flex" style="gap: 10px">
          <b-button class="button justify-content-center add-skill-button" variant="success" style="height: 32px;"
            @click="addNewSkill">
            Add skills
          </b-button>
          <b-button class="button justify-content-center chevron-button" style="height: 32px;" variant="plain"
            @click="toggleShowingSkills" :disabled="!userSelectedSkills.length">
            <span class="material-symbols-outlined material-symbols-fill-1 mr-1 ml-2"
              :style="{ transform: !showSkills ? 'rotate(180deg)' : 'none', transition: '0.2s' }">
              keyboard_arrow_down
            </span>
          </b-button>
        </div>
      </template>
    </PageHeader>
    <b-collapse v-if="userSelectedSkills.length" v-model="showSkills">
      <div class="row">
        <label class="col-6 pr-12px form__label">Skill</label>
        <label class="col-6 pl-12px form__label">Assessment</label>
        <div />
      </div>
      <div class="row mb-3" v-for="(_skill, index) in userSelectedSkills" :key="`${index}_skill`">
        <div class="col-6 pr-12px">
          <multiselect v-model="userSelectedSkills[index].skill" :options="userSkills" :allow-empty="false"
            :showLabels="false" label="name" track-by="id" placeholder="Select skill" name="skill_name"/>
          <div v-show="!userSelectedSkills[index].skill && showErrors" class="form-generator__error">
            <div>
              Field is required
            </div>
          </div>
        </div>

        <div class="col-6 pl-12px">
          <div class="d-flex align-center gap-10">
            <multiselect v-model="userSelectedSkills[index].scale" :options="skillScale"
            :allow-empty="false" :showLabels="false" name="skill_value"/>
            <b-button :key="`${index}_btn`" variant="error" class="button button-wrap btn-icon btn-danger w-100"
              @click="deleteSkill(index)">
            <span v-html="removeIconSvg"></span>
          </b-button>
        </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import PageHeader from '@components/PageHeader.vue'
import removeIcon from '@/assets/icons/removeIcon'

export default {
  name: 'NewUserProfileSkills',
  components: { PageHeader },
  emits: ['update'],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    showSkillsError: Boolean
  },

  data () {
    return {
      removeIconSvg: removeIcon(),
      fields: [
        {
          label: 'Name',
          key: 'name'
        },
        {
          label: 'Assessment',
          key: 'value'
        },
        {
          label: 'Actions',
          key: 'Actions'
        }
      ],
      showSkills: true,
      skills: [],
      skillScale: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      newSkill: {
        skill: null,
        scale: 1
      }
    }
  },

  mounted () {
    this.getSkills()
  },

  computed: {
    userSelectedSkills: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('update', newValue)
      }
    },

    showErrors () {
      return this.showSkillsError
    },

    userSkills () {
      const selected = this.userSelectedSkills.map(skill => skill.skill?.id)
      return this.skills.filter((s) => !selected.includes(s.id))
    },

    skillValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },

  methods: {
    addNewSkill () {
      if (!this.showSkills) {
        this.showSkills = true
      }
      let emptySkill = { ...this.newSkill }
      this.userSelectedSkills.push(emptySkill)
    },
    toggleShowingSkills () {
      this.showSkills = !this.showSkills
    },
    deleteSkill (index) {
      this.userSelectedSkills.splice(index, 1)
    },
    getSkills () {
      this.axios({
        method: 'get',
        url: '/api/skills',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
        .then((response) => {
          this.skills = response.data
        })
        .catch((err) => {
          this.errorNotifications(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

.button-wrap {
  width: 50px !important;
}

.button-width {
  width: calc(50px + 0.75rem * 2) !important;
}

.add-skill-button {
  min-width: 140px;
  font-size: 14px;
  font-weight: 700;
  font-family: $font-family-second;
  text-transform: uppercase;
}

</style>
